import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Projects } from "@/components/site/Projects";
import { Articles } from "@/components/site/Articles";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    const hash = window.location.hash?.slice(1);
    if (hash) {
      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#050a14]">
      <Navbar />
      <Hero />
      <Articles />
      <Projects />
      <Footer />
    </div>
  );
}
